var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricesEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#627eea",
    height: 40,
    rx: 20,
    width: 40,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.6226 5.00049v11.08751l9.3712 4.1875z",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.6225 5.00049-9.3725 15.27501 9.3725-4.1875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.6226 27.4605v7.5338l9.3775-12.9738z",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.6225 34.9943v-7.535l-9.3725-5.4388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.6226 25.7167 9.3712-5.4412-9.3712-4.185z",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.25 20.2755 9.3725 5.4412v-9.6262z",
    fillOpacity: 0.602
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricesEth);
export default __webpack_public_path__ + "static/media/prices-eth.714090716100d7b7601912fe2e03184e.svg";
export { ForwardRef as ReactComponent };